/**
 * Checks if the contents of two arrays are the same, regardless of order.
 * @param a an Array to compare
 * @param b an Array to compare
 */
export const sameValues = (a: any[], b: any[]): boolean => {
  if (a === b) {
    return true;
  }
  if (a === null || b === null) {
    return false;
  }
  if (a.length !== b.length) {
    return false;
  }

  const copyA = [...a];
  const copyB = [...b];

  copyA.sort();
  copyB.sort();

  for (let i = 0; i < copyA.length; ++i) {
    if (copyA[i] !== copyB[i]) {
      return false;
    }
  }

  return true;
};
